import { defaults } from "../../styles";

export const Container = defaults.Container;
